import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { SecondPageIndexBase } from 'vnpost-shared';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { WeightConfigurationAddComponent } from './weight-configuration-add/weight-configuration-add.component';
import { WeightConfigurationEditComponent } from './weight-configuration-edit/weight-configuration-edit.component';
import { WeightConfigurationService } from '../services/weight-configuration.service';

@Component({
  selector: 'app-weight-configuration',
  templateUrl: './weight-configuration.component.html',
  styleUrls: ['./weight-configuration.component.css']
})
export class WeightConfigurationComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: WeightConfigurationAddComponent;
  @ViewChild('pEdit', { static: false }) pEdit: WeightConfigurationEditComponent;
  // @ViewChild('pRestorePasswd', { static: false }) pRestorePasswd: WeightConfigurationResetpasswdComponent;
  // @ViewChild('pImport') pImport: WeightConfigurationImportComponent;

  unitCode = this.currentUser?.unitCode;
  listUnit: { label: string; value: string }[] = [];

  code: any;
  formGroup: any;

  constructor(
    protected _injector: Injector,
    protected _weightConfigurationService: WeightConfigurationService
  ) {
    super(_weightConfigurationService, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
  }

  ngOnInit() {
    this.loadTableColumnConfig();
    this.getData();
  }

  loadTableColumnConfig() {
    this.cols = [
      { field: 'productCode', header: 'Mã Sản phẩm', visible: true, sort: true },
      { field: 'productName', header: 'Tên Sản phẩm', visible: true, sort: true },
      { field: 'unitCode', header: 'Mã đơn vị quản lý', visible: true, sort: true },
      { field: 'salesWeight', header: 'Cấu hình trọng số tính ra Doanh thu (theo doanh số bán) (%)', visible: true, },
      { field: 'totalWeight', header: 'Cấu hình trọng số tính ra Tổng thù lao (theo doanh số bán) (%)', visible: true, },
      { field: 'receivedWeight', header: 'Cấu hình trọng số tính ra Tổng thù lao thực nhận (theo doanh số bán) (%)', visible: true, },
      { field: 'revenue', header: 'Doanh thu', visible: true, },
      { field: 'totalRemuneration', header: 'Tổng thù lao', visible: true, },
      { field: 'remunerationReceived', header: 'Tổng thù lao được nhận', visible: true, },
      { field: 'status', header: 'Trạng thái áp dụng', visible: true, },
      { field: 'action', header: 'Hành động', visible: true, },
    ];
  }

  async getData() {
    this.isLoading = true;
    var model = {
      search: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize,
      unitCode: this.unitCode
    }
    await this._weightConfigurationService.getAll(model)
      .then(response => {
        this.dataSource = response.data;
        this.dataSource.forEach(x => {
          x.unitCode = x.unitcodeList?.map(x => x.unitCode)?.join(',');
        });
        this.totalRecord = response.total;
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showHttpUnknowError();
      });

  }

  editWeightConfiguration(item: any) {
    if (item && item.id) {
      this.pEdit.showPopup(item.id);
    }
  }

  add() {
    this.pCreate.showPopup();
  }

  deleteWeightConfiguration(item: any) {
    if (item && item.id) {
      this._notifierService
        .showConfirm('Bạn có chắc muốn ngừng hoạt động sản phẩm này')
        .then((res) => {
          if (res) {
            this._weightConfigurationService.delete(item.id).then(res => {
              this._notifierService.showDeleteDataSuccess();
              this.getData();
            }, err => {
              this._notifierService.showDeleteDataError();
            });
          }
        });
    }
  }

  onImport() {
    // this.pImport.showPopup();
  }
}